import React from 'react';
import styles from './ProductBasicInfo.module.scss';

const ProductBasicInfo = ({
  formData,
  errors,
  companies,
  warehouses,
  updateFormData,
  clearError
}) => {
  const storageTypes = [
    { value: "dry", label: "Dry" },
    { value: "frozen", label: "Frozen" }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    updateFormData(name, value);
    clearError(name);
  };

  const handleSelectFocus = (fieldName) => {
    clearError(fieldName);
  };

  // Helper function to determine select color
  const getSelectColor = (value) => {
    return value ? '#000000' : '#797775';
  };

  return (
    <>
      {/* Product Type Selection */}
      <div className={`${styles.label_input}`}>
        <label>Product Type</label>
        <div className={styles.input_container}>
          <select
            name="productType"
            value={formData.productType}
            onChange={handleInputChange}
            onFocus={() => handleSelectFocus('productType')}
            className={styles.select_field}
            style={{ color: getSelectColor(formData.productType) }}
          >
            <option value="non-perishable">Non-Perishable</option>
            <option value="perishable">Perishable</option>
          </select>
        </div>
      </div>

      {/* Company Selection */}
      <div className={`${styles.label_input} ${errors.company_id ? styles.error : ''}`}>
        <label>Select Company<span>*</span></label>
        <div className={styles.input_container}>
          <select
            name="company_id"
            value={formData.company_id}
            onChange={handleInputChange}
            onFocus={() => handleSelectFocus('company_id')}
            className={styles.select_field}
            style={{ color: getSelectColor(formData.company_id) }}
          >
            <option value="" disabled hidden>Select Company</option>
            {companies.filter(company => company.status === 1).map(company => (
              <option key={company.id} value={company.id}>{company.company_name}</option>
            ))}
          </select>
          {errors.company_id && <span className={styles.errorMessage}>{errors.company_id}</span>}
        </div>
      </div>

      {/* Product Name */}
      <div className={`${styles.label_input} ${errors.product_name ? styles.error : ''}`}>
        <label>Product Name<span>*</span></label>
        <div className={styles.input_container}>
          <input
            type="text"
            name="product_name"
            value={formData.product_name}
            onChange={handleInputChange}
            onFocus={() => clearError('product_name')}
            placeholder="Enter Product Name"
          />
          {errors.product_name && <span className={styles.errorMessage}>{errors.product_name}</span>}
        </div>
      </div>

      {/* Warehouse Selection */}
      <div className={`${styles.label_input} ${errors.warehouse_id ? styles.error : ''}`}>
        <label>Select Warehouse<span>*</span></label>
        <div className={styles.input_container}>
          <select
            name="warehouse_id"
            className={styles.select_field}
            value={formData.warehouse_id}
            onChange={handleInputChange}
            onFocus={() => handleSelectFocus('warehouse_id')}
            style={{ color: getSelectColor(formData.warehouse_id) }}
          >
            <option value="" hidden>Select Warehouse</option>
            {warehouses.filter(warehouse => warehouse.status === 1).map(warehouse => (
              <option key={warehouse.id} value={warehouse.id}>
                {warehouse.name}
              </option>
            ))}
          </select>
          {errors.warehouse_id && <span className={styles.errorMessage}>{errors.warehouse_id}</span>}
        </div>
      </div>
    </>
  );
};

export default ProductBasicInfo;